export default {
  addShopSuccess: 'Articolo aggiunto con successo',
  addShopFail: "Impossibile aggiungere l'articolo",
  getCartDataFail: 'Impossibile recuperare gli articoli dal carrello',
  hint: 'Suggerimento',
  delConfirmProduct: 'Sei sicuro di voler eliminare questo prodotto?',
  confirm: 'Conferma',
  cancel: 'Annulla',
  productInfo: 'Dettagli del prodotto',
  unitPrice: 'Prezzo unitario',
  num: 'Qtà',
  subtotal: 'Subtotale',
  action: 'Azione',
  productName: 'Nome del prodotto',
  splitProduct: 'Dividi prodotto',
  split: 'Dividi',
  allSelect: 'Seleziona tutto',
  delProduct: 'Elimina selezione',
  selected: 'Selezionato',
  piece: 'Articolo(i)',
  total: 'Totale',
  productTotal: 'Escluse spese di spedizione internazionale',
  orderPay: "Procedi all'ordine",
  orderTotal: 'Totale ordine',
  goCartPay: 'Visualizza carrello',
  moreView: 'Altri articoli nel carrello',
  noSelectText: 'Non hai selezionato alcun prodotto al momento',
  paySuccess: 'Pagamento riuscito!',
  returnPayment: 'Torna per continuare il pagamento',
  service: 'Servizio',
  goodsMinNumErrTips:
    'Questo prodotto richiede una quantità minima di acquisto di {num}, puoi scegliere diverse specifiche in base alle tue esigenze.',
  balckShop: 'Il negozio è nella lista nera',
  forbidBuy: 'Negozio a rischio, acquisto vietato',
  riskTip: 'Negozi a rischio, si prega di acquistare con cautela',
  riskReminder: 'Promemoria sui rischi',
  blackenedShop: 'Negozio inserito nella lista nera',
  riskProducts: 'Prodotti a rischio',
  riskMsg1:
    "Potrebbe esserci un certo rischio associato ai prodotti che stai per inviare. Per la tua sicurezza finanziaria, al momento non siamo in grado di fornirti servizi di ordinazione online. Per maggiori informazioni, contatta il servizio clienti o l'acquisto specializzato.",
  riskMsg2:
    'I prodotti che stai per inviare potrebbero presentare un certo rischio di spedizione. Per la tua sicurezza finanziaria, al momento non siamo in grado di fornirti servizi di ordinazione online. Per maggiori informazioni, contatta il servizio clienti online!',
  riskMsg3:
    "Il prodotto che stai acquistando potrebbe essere un articolo specializzato o di marca. Non abbiamo la capacità di autenticarne l'originalità e possiamo offrire solo servizi di approvvigionamento e ispezione di qualità di base. Tutti i potenziali rischi devono essere assunti da te.",
  continueToBuy: 'Continua ad acquistare altri articoli',
  buyOthers: 'Acquista altri articoli',
  continuePurchasing: 'Continua gli acquisti',
}
